export const mapBoxKey = import.meta.env.VITE_MAPBOX_API_KEY as string ?? ''
